module.exports = {
    Description: {
        StaticInfo: `
        <p>
        The lessons learned are the knowledge acquired through experience in the operations in which the team has participated. For operations in the hydrocarbon industry, the reasons for success or failure, the foundation of lessons learned, generally requires time for analysis, testing and measurement. However, the lessons learned throughout the process must be documented, at the very moment that we acquire such knowledge. 
        </p>
        `,
        SectionsInfo: []
    },
    Overview: {
        StaticInfo: "<p>The lessons learned are a valuable tool for use and support in other projects or operations.</p>",
        SectionsInfo: [{
            title: "Among the advantages of their appropriate documentation, the following are to be mentioned",
            content: `
                <ul>
        <li>Help to detect opportunities for improvement based on the experiences obtained and good practices</li>
        <li>Offer support information for better decision making in situations that may occur in future
            projects</li>
        <li>Improves the planning of future projects, avoiding previous mistakes and, therefore, reduces future risks
        </li>
        <li>Help to reduce uncertainty and improve response-time in similar situations</li>
    </ul>
                `,

        },
        {
            title: "The lessons learned should address the following concerns ",
            content: `
                <ul>
                    <li>What went well in the project or operation and what went wrong</li>
                    <li>Which objectives were not achieved in the Project (date, cost, quality, production, etc.)</li>
                    <li>What was the cause of these successes or failures in the Project</li>
                    <li>Which unplanned events (unexpected events) occurred in the Project and what were their consequences</li>
                    <li>Which things were not planned in the Project and what were the consequences</li>
                </ul>
                `
        },
        {
            title: "Some rules for a lessons learned meeting with team members",
            content: `
                <ul>
                <li>Do not constrain people on the questions. Let them tell you what they want to tell you</li>
                <li>Everybody can share their views openly</li>
                <li>There is no good or bad feedback. <strong>Any feedback is appreciated</strong></li>
                <li>Avoid personal attacks or calling names. If somebody wants to complain about a specific individual, they can
                    use the title instead, e.g. saying ‘the head of logistics’ instead of Brian Johnson</li>
            </ul>
                `
        }, {
            title: "Impact of the Lessons Learned",
            content: `
                <p>
                The Lessons Learned Review will lead to, after the end of this Project, to a group of Remedial Actions
                (interpret it as adjustments) to be made in whichever stage of the operation requires them. Whether the issue
                resulted from an inadequate preliminary data search, or the finding of a property “out of range” in the data
                base or ANY OTHER FINDING, every lesson learned has to be translated into future action.
                The specific client will be informed of the adjustments that have been made to accommodate for “each lesson
                learned”. Since EGEP publishes a regular newsletter, “after sanitizing the lesson learned” so that it becomes
                unrelatable to a specific client, the improvement in the process will be shared with the <strong>past and future</strong> users
                of the system.
                </p>
                `,
        }
        ]
    },
    Inputs: {
        StaticInfo: `
        <p>
        In this section the purpose is to help you document the lessons learned with knowledge gained during the process. Please consider answering the items indicated below with the EGEP consultant´s support.<br>
        <br>
        <li>Project or operation name</li>
        <li>Project start and end date</li>
        <li>Service company executing the project or operation</li>
        <li>Project Leader</li>
        <li>Team members</li>
        <li>Topic: name with which you can quickly identify the topic of the lesson learned</li>
        <li>Description of the operation: describes in detail the situation that the team had to face</li>
        <li>Operation phase: indicates the phase of the process life cycle where the lesson occurred</li>
        <li>Actions implemented: describe in detail the decisions taken or actions taken to face the situation, achieve success, avoid failure or solve the problem</li>
        <li>Results obtained in the operation: describe in detail the results obtained by the actions implemented. This item answers the questions: what went well? and / or what went wrong?</li>
        <li>Recommendation: describe what actions should be repeated, avoided and / or what others can be implemented for future projects</li>
        <li>Impact of the Lessons Learned on the results obtained:</li>
        </p>
        <div style="width:100%;">
    <img style="width:100%;" src='https://firebasestorage.googleapis.com/v0/b/practica-9c4fb.appspot.com/o/Imagen_Inputs_5_1_.JPG?alt=media&token=f8b0df7c-1e94-421d-9703-428df814b2e9' />
    </div>
        `,
        SectionsInfo: []
    },

}